import api, { endpoints } from '@utils/api';

/**
 * GET /company-role-permissions/role/:company_role_id
 */
export const getCompanyRolePermissions = async (companyRoleId) => {
  const response = await api.get(
    `${endpoints.companyRolePermissions}/role/${companyRoleId}`
  );
  return response.data;
};

/**
 * Replace permissions for a company role. Backend: POST /company-role-permissions/save/:company_role_id
 * Body: { permissions: [{ page_id, can_view?, can_create?, can_edit?, can_delete? }] }
 */
export const saveCompanyRolePermissions = async (companyRoleId, body) => {
  const response = await api.post(
    `${endpoints.companyRolePermissions}/save/${companyRoleId}`,
    body
  );
  return response.data;
};
